module.exports = __webpack_public_path__ + "static/media/view.c1a4414f.svg";